module.exports = __webpack_public_path__ + "static/ValtellinaPalace_plani_1591-2loc-24v3-5dd9d7f7bf57b2d15af430d1ec3b4c06.jpg";